import ExoForm from '../../../components/exo/ExoForm';
import { useTranslation } from 'react-i18next';
import { API_POST, DBRequest, useConfig } from '../../../api/api';
import moment from 'moment';
import { useState } from 'react';
import * as Yup from 'yup';
import { Box } from '@mui/material';

export const GenerateReimbursements = ({
  onResponse,
  onClose,
  onFeedback = () => {},
}) => {
  const { t } = useTranslation();
  const config = useConfig();
  const [isLoading, setIsLoading] = useState(false);

  function createElement(data) {
    const reqData = {
      year: parseInt(data.year),
      month: parseInt(data.month),
    };
    DBRequest({
      config,
      path: 'travel-expense-reimbursements/generate/all',
      method: API_POST(reqData),
      onResponse: onResponse,
      onLoading: setIsLoading,
      onFeedback,
    });
  }

  const fields = [
    {
      label: t('Year'),
      key: 'year',
      type: 'date',
      format: 'YYYY',
      views: ['year'],
    },
    {
      label: t('Month'),
      key: 'month',
      type: 'date',
      format: 'MM',
      views: ['month'],
    },
  ];

  const [defaultValues] = useState({
    year: moment().format('YYYY'),
    month: moment().format('MM'),
  });

  const validationSchema = Yup.object().shape({
    year: Yup.string().required(t('Is required')),
    month: Yup.string().required(t('Is required')),
  });

  return (
    <Box className="p-4">
      <ExoForm
        startDataCollection={defaultValues}
        className="flex flex-col gap-4"
        header={t('Generate Reimbursements')}
        fields={fields}
        onCancel={onClose}
        submitText={t('Generate')}
        onSubmit={createElement}
        isLoading={isLoading}
        validationSchema={validationSchema}
        noDifferences
      />
    </Box>
  );
};
